<template>
  <button
    type="button"
    id="btn"
    :class="[
      'flex items-center justify-center w-min shadow-md hover:!disabled:shadow-sm select-none',
      this.isFilled ? 'filled' : '',
      this.isDisabled ? 'disabled' : '',
    ]"
  >
    <PlayIcon v-if="this.hideIcon === false && this.icon === 'play'" class="h-5 w-5 md:h-6 md:w-6" />
    <PlusCircleIcon v-if="this.hideIcon === false && this.icon === 'plus'" class="h-5 w-5 md:h-6 md:w-6" />
    <MinusCircleIcon v-if="this.hideIcon === false && this.icon === 'minus'" class="h-5 w-5 md:h-6 md:w-6" />
    <ForwardIcon v-else-if="this.hideIcon === false && this.icon === 'fast-forward'" class="h-5 w-5 md:h-6 md:w-6" />
    <CheckIcon v-else-if="this.hideIcon === false && this.icon === 'check'" class="h-5 w-5 md:h-6 md:w-6" />
    <XMarkIcon v-else-if="this.hideIcon === false && this.icon === 'x'" class="h-5 w-5 md:h-6 md:w-6" />
    <BookmarkIcon v-else-if="this.hideIcon === false && this.icon === 'bookmark'" class="h-5 w-5 md:h-6 md:w-6" />
    <ShareIcon v-else-if="this.hideIcon === false && this.icon === 'share'" class="h-5 w-5 md:h-6 md:w-6" />
    <ClipboardDocumentCheckIcon v-else-if="this.hideIcon === false && this.icon === 'clipboard-check'" class="h-5 w-5 md:h-6 md:w-6" />
    <EnvelopeIcon v-else-if="this.hideIcon === false && this.icon === 'mail'" class="h-5 w-5 md:h-6 md:w-6" />
    <div v-if="this.text.length > 0" :class="this.hideIcon === false ? 'ml-2' : ''">{{ text }}</div>
  </button>
</template>

<script>
import {
  PlayIcon,
  PlusCircleIcon,
  MinusCircleIcon,
  ForwardIcon,
  CheckIcon,
  XMarkIcon,
  BookmarkIcon,
  ShareIcon,
  ClipboardDocumentCheckIcon,
  EnvelopeIcon,
} from '@heroicons/vue/24/outline';

export default {
  name: 'GenericButton',
  components: {
    PlayIcon,
    PlusCircleIcon,
    MinusCircleIcon,
    ForwardIcon,
    CheckIcon,
    XMarkIcon,
    BookmarkIcon,
    ShareIcon,
    ClipboardDocumentCheckIcon,
    EnvelopeIcon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    isFilled: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
#btn {
  min-width: 44px;
  height: fit-content;
  padding: 0 1rem;
  border-radius: 2rem;
  font-size: 1rem;
  line-height: 2.75rem;
  background-color: #99397322;
  transition: background-color 250ms;
  white-space: nowrap;
  color: #993973;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  #btn {
    font-size: 0.875rem;
    line-height: 2.25rem;
    min-height: 36px;
  }
}

@media screen and (min-width: 768px) {
  #btn {
    min-height: 44px;
  }
}

#btn.filled {
  background-color: #993973;
  color: white;
}

#btn.disabled {
  color: #666;
  background-color: #eee;
  cursor: not-allowed;
}

#btn:hover:not(.disabled) {
  background-color: #99397355;
  color: #1f1f1f;
}

#btn.filled:hover {
  background-color: #993973dd;
  color: white;
}

#btn.success,
#btn.disable.success {
  background-color: #00770022;
  color: #005500cc;
}
</style>
